import CrudTable, { TextField, TextArea, CheckField, ImageField, SelectField } from './CrudTable';

const CATEGORIES = ['Design', 'Engineering', 'Growth'];

export default function AdminPosts() {
  return (
    <CrudTable
      table="blog_posts"
      title="Blog posts"
      itemLabel="blog post"
      publicPath={it => it.slug ? `/blog/${it.slug}` : null}
      defaults={{ slug: '', title: '', excerpt: '', cover: '', category: 'Design', author: 'Slinkflow', read_minutes: 5, content: '', featured: false, published_at: new Date().toISOString().slice(0,10), meta_title: '', meta_description: '' }}
      columns={[
        { key: 'title', label: 'Title' },
        { key: 'category', label: 'Category', className: 'col-span-2' },
        { key: 'author', label: 'Author', className: 'col-span-2' },
        { key: 'published_at', label: 'Date', className: 'col-span-2', format: v => v > new Date().toISOString().slice(0, 10) ? `${v} (scheduled)` : v },
      ]}
      render={(it, set) => (
        <>
          <TextField label="Title" value={it.title} onChange={v => set({ ...it, title: v })} required />
          <TextField label="Slug" value={it.slug} onChange={v => set({ ...it, slug: v })} required />
          <ImageField label="Cover image" folder="blog" value={it.cover} onChange={v => set({ ...it, cover: v })} />
          <SelectField label="Category" value={it.category} options={CATEGORIES} onChange={v => set({ ...it, category: v })} />
          <TextField label="Author" value={it.author} onChange={v => set({ ...it, author: v })} />
          <TextField label="Read minutes" type="number" value={it.read_minutes} onChange={v => set({ ...it, read_minutes: v })} />
          <TextField label="Published date" type="date" value={it.published_at} onChange={v => set({ ...it, published_at: v })} />
          <TextArea label="Excerpt" value={it.excerpt} onChange={v => set({ ...it, excerpt: v })} />
          <div>
            <TextArea label="Content" value={it.content} onChange={v => set({ ...it, content: v })} rows={10} />
            <p className="mt-1.5 text-xs text-ink-400">Markdown supported: <code># Heading</code>, <code>## Subheading</code>, <code>**bold**</code>, <code>[link text](https://example.com)</code>, <code>&gt; quote</code>, <code>1. numbered</code> and <code>- bullet</code> lists, separated by blank lines. Every <code>##</code> heading automatically appears in the post's "In this post" sidebar.</p>
          </div>
          <CheckField label="Featured" value={it.featured} onChange={v => set({ ...it, featured: v })} />
          <div className="border-t border-ink-100 pt-4">
            <p className="text-xs font-medium uppercase tracking-[0.2em] text-ink-400">SEO (optional — falls back to title/excerpt if left blank)</p>
          </div>
          <TextField label="Meta title" value={it.meta_title} onChange={v => set({ ...it, meta_title: v })} />
          <TextArea label="Meta description" value={it.meta_description} onChange={v => set({ ...it, meta_description: v })} rows={2} />
        </>
      )}
    />
  );
}
